export class zFactorsBomDTO {

    id: number;
    zFactorId:number;
    itemName: string;
    imCode:string;
    description: string;
    geoCode: string;
    destination: string;
    size:string;
    gender:string;
    plant:string;
    style:string;
    sequence:number;
    
    constructor(
        id:number,
        zFactorId:number,
        itemName:string,
        imCode:string,
        description:string,
        geoCode:string,
        destination:string,
        size:string,
        gender:string,
        plant:string,
        style:string,
        sequence:number
    
            )
            {
           this.id=id
           this.zFactorId=zFactorId
           this.itemName=itemName    
           this.imCode=imCode
           this.description=description
           this.geoCode=geoCode
           this.destination=destination
           this.size=size
           this.gender=gender
           this.plant=plant
           this.style=style
           this.sequence=sequence
        }
}

